import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLyricsAi = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9.15609 1.875C9.50125 1.875 9.78109 2.15483 9.78109 2.5C9.78109 2.84517 9.50125 3.125 9.15609 3.125H6.48519C5.41545 3.125 4.59137 3.49952 4.03158 4.09993C3.46724 4.70538 3.125 5.59125 3.125 6.68864V13.3114C3.12501 14.4095 3.46589 15.295 4.02913 15.9001C4.58767 16.5001 5.41131 16.875 6.48519 16.875H13.5132C14.5876 16.875 15.412 16.5001 15.9709 15.9001C16.5343 15.295 16.875 14.4094 16.875 13.3114V8.35531C16.875 8.01012 17.1548 7.73031 17.5 7.73031C17.8452 7.73031 18.125 8.01012 18.125 8.35531V13.3114C18.125 14.6676 17.7011 15.8765 16.8856 16.7521C16.0654 17.6327 14.8962 18.125 13.5132 18.125H6.48519C5.10239 18.125 3.93345 17.6328 3.11361 16.7521C2.29849 15.8765 1.87501 14.6675 1.875 13.3114V6.68864C1.875 5.33172 2.30102 4.12316 3.11686 3.24788C3.93726 2.36772 5.10563 1.875 6.48519 1.875H9.15609Z",
			fill: "url(#paint0_linear_7052_71150)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.625 13.0225C10.9702 13.0225 11.25 13.3022 11.25 13.6475C11.25 13.9926 10.9702 14.2725 10.625 14.2725H6.12305C5.77788 14.2725 5.49805 13.9926 5.49805 13.6475C5.49805 13.3022 5.77788 13.0225 6.12305 13.0225H10.625Z",
			fill: "url(#paint1_linear_7052_71150)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.8737 9.92025C14.2188 9.92025 14.4987 10.2001 14.4987 10.5452C14.4987 10.8904 14.2189 11.1702 13.8737 11.1702H6.1735C5.82833 11.1702 5.5485 10.8904 5.5485 10.5452C5.54852 10.2001 5.82834 9.92025 6.1735 9.92025H13.8737Z",
			fill: "url(#paint2_linear_7052_71150)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.3084 4.07796C10.5835 4.07796 10.8265 4.25747 10.9066 4.52067C11.03 4.92672 11.3475 5.24451 11.7521 5.36784C12.0149 5.44814 12.1948 5.69039 12.1948 5.96517C12.1948 6.24006 12.015 6.48305 11.7521 6.56331C11.3476 6.68663 11.03 7.00367 10.9066 7.40967C10.8266 7.67296 10.5836 7.85319 10.3084 7.85319C10.0334 7.85308 9.79026 7.67288 9.71029 7.40967C9.58682 7.00374 9.27006 6.68661 8.86556 6.56331C8.60248 6.48313 8.42285 6.24015 8.42285 5.96517C8.42292 5.6903 8.6026 5.44805 8.86556 5.36784C9.27014 5.24451 9.58687 4.92671 9.71029 4.52067C9.79027 4.25748 10.0334 4.07807 10.3084 4.07796ZM10.2458 5.96517C10.2671 5.98582 10.2878 6.00725 10.3084 6.02865C10.3291 6.00725 10.3506 5.98582 10.3719 5.96517C10.3506 5.94452 10.3291 5.9239 10.3084 5.90251C10.2879 5.92378 10.267 5.94464 10.2458 5.96517Z",
			fill: "url(#paint3_linear_7052_71150)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M15.5957 1.875C15.8573 1.87506 16.091 2.03815 16.1816 2.28353L16.2557 2.48372C16.4719 3.06912 16.9332 3.53036 17.5171 3.74674L17.7173 3.8208C17.9625 3.91164 18.125 4.14614 18.125 4.40755C18.1249 4.6688 17.9623 4.90267 17.7173 4.99349L17.5171 5.06755C16.9331 5.28393 16.4719 5.74517 16.2557 6.33057L16.1816 6.53076C16.091 6.77613 15.8573 6.93923 15.5957 6.93929C15.3341 6.93929 15.0996 6.77617 15.009 6.53076L14.9349 6.33057C14.7186 5.74522 14.2583 5.28394 13.6743 5.06755L13.4741 4.99349C13.2291 4.90269 13.0665 4.66884 13.0664 4.40755C13.0664 4.14613 13.229 3.91163 13.4741 3.8208L13.6743 3.74674C14.2582 3.53034 14.7186 3.06907 14.9349 2.48372L15.009 2.28353C15.0996 2.03811 15.3341 1.875 15.5957 1.875ZM15.5957 3.83382C15.4285 4.04712 15.236 4.24011 15.0228 4.40755C15.2359 4.57497 15.4285 4.76721 15.5957 4.98047C15.763 4.76718 15.9555 4.57498 16.1686 4.40755C15.9555 4.24011 15.763 4.04712 15.5957 3.83382Z",
			fill: "url(#paint4_linear_7052_71150)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_7052_71150",
				x1: 1.875,
				y1: 10,
				x2: 18.125,
				y2: 10,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6366F1" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#F43F5E"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_7052_71150",
				x1: 1.875,
				y1: 10,
				x2: 18.125,
				y2: 10,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6366F1" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#F43F5E"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_7052_71150",
				x1: 1.875,
				y1: 10,
				x2: 18.125,
				y2: 10,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6366F1" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#F43F5E"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_7052_71150",
				x1: 1.875,
				y1: 10,
				x2: 18.125,
				y2: 10,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6366F1" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#F43F5E"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_7052_71150",
				x1: 1.875,
				y1: 10,
				x2: 18.125,
				y2: 10,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6366F1" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#F43F5E"
				})]
			})
		] })
	]
});
export default SvgLyricsAi;
